import { MsalProvider } from '@azure/msal-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import { msalInstance } from 'src/config/msalConfig'
import ThemeProvider from 'src/theme'

export const queryClient = new QueryClient()
export const AppWraper = ({ children }) => {
  return (
    <HelmetProvider>
      <MsalProvider instance={msalInstance}>
        <ThemeProvider>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>{children}</BrowserRouter>
          </QueryClientProvider>
        </ThemeProvider>
      </MsalProvider>
    </HelmetProvider>
  )
}
